import React, { FC, useEffect } from 'react';
import nebulaTheme from '@nebula/theme';
import { InfoIcon, iconSizes } from '@nebula/icons/ui';
import {
  Container,
  BodyContent,
  IconContainer,
  TextContainer,
  Title,
  Subtitle,
  ActionButton,
} from './index.styles';

interface ErrorScreenProps {
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  onTryAgain: () => void;
}

const ErrorScreen: FC<ErrorScreenProps> = ({
  title = 'We could not show your information',
  subtitle = 'It was an issue at our end. You have not been charged.',
  buttonLabel = 'Try again',
  onTryAgain,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <BodyContent>
        <IconContainer>
          <InfoIcon iconSize={iconSizes.large} iconColor={nebulaTheme.color.ui.grey[100]} />
        </IconContainer>
        <TextContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TextContainer>
        <ActionButton label={buttonLabel} onClick={onTryAgain} />
      </BodyContent>
    </Container>
  );
};

export default ErrorScreen;
